<template lang="pug">
  .page
    section
      b-container
        h1 Something went wrong during payment
        h4 Your order could not be placed
        p We'll reserve this piece for you for one hour, should you wish to try again.
        b-button.btn-outline(:to="{name: 'AccountOrders'}") COMPLETE ORDER

</template>

<script>

export default {
  name: 'OrderOk',
  components: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/OrderNotOk.vue